import api from '@/apis'

export const getProduct = (id, params) => api.get(`/products/${id}`, { params })
export const fetchList = (tenantId, params) => api.get(`/products?tenant=${tenantId}`, { params })
export const setActiveState = (id, isActive) => api.put(`/products/${id}/delete`, { isActive })
